module.exports = __webpack_public_path__ + "img/empty-add-class.0e31efe0.svg";